import type { ReactNode } from 'react';
import type { SxProps, Theme } from '@mui/material';

import { Avatar } from '@mui/material';

import { imageOutlineSx } from '../../theme/surfaces';

// ----------------------------------------------------------------------

export interface AccountAvatarProps {
  src?: string;
  alt?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps<Theme>;
  /** Fallback content (e.g. initials) shown when no image is available. */
  children?: ReactNode;
}

export function AccountAvatar({ src, alt, onClick, sx, children }: AccountAvatarProps) {
  return (
    <Avatar
      src={src}
      alt={alt ?? ''}
      onClick={onClick}
      slotProps={{ img: { fetchPriority: 'high' } }}
      sx={[
        (theme) => ({
          width: 40,
          height: 40,
          cursor: onClick ? 'pointer' : 'default',
          bgcolor: 'grey.700',
          ...imageOutlineSx(theme),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Avatar>
  );
}
